import { createIcon } from "@chakra-ui/react";

const TextFieldsIcon = createIcon({
  displayName: "TextFieldsIcon",
  viewBox: "0 0 24 24",
  path: <path d="M7 20V7H2V4h13v3h-5v13H7Zm9 0v-8h-3V9h9v3h-3v8h-3Z" fill="currentColor" />,
});

export default TextFieldsIcon;
